/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ---------------------------------------------------------------------------
 * nutriride: off-canvas drawer behaviour (sections/nutriride-drawer.liquid)
 *
 * Warehouse's condensed header opens a small dropdown panel. We intercept its
 * menu buttons in the CAPTURE phase and stop the theme's own handler, then open
 * the full-height drawer instead. Capture phase plus stopImmediatePropagation is
 * required because theme.js binds on the same element.
 * --------------------------------------------------------------------------- */
(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-nr-drawer]');
    var overlay = document.querySelector('[data-nr-overlay]');
    if (!drawer || !overlay) return;

    function open() {
      overlay.hidden = false;
      // next frame, so the transition runs from the hidden state
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        drawer.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nr-drawer-open');
      var first = drawer.querySelector('.nr-drawer__close');
      if (first) first.focus();
    }

    function close() {
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nr-drawer-open');
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) overlay.hidden = true;
      }, 280);
    }

    // Intercept Warehouse's menu toggles (mobile + desktop) before theme.js sees them
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-action="toggle-menu"]');
      if (!toggle) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (drawer.classList.contains('is-open')) { close(); } else { open(); }
    }, true);

    overlay.addEventListener('click', close);

    var closeBtn = drawer.querySelector('[data-nr-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Tabs
    drawer.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-nr-tab]');
      if (!tab) return;
      var name = tab.getAttribute('data-nr-tab');
      drawer.querySelectorAll('[data-nr-tab]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      drawer.querySelectorAll('[data-nr-panel]').forEach(function (p) {
        var on = p.getAttribute('data-nr-panel') === name;
        p.classList.toggle('is-active', on);
        p.hidden = !on;
      });
    });

    // Accordion
    drawer.addEventListener('click', function (event) {
      var parent = event.target.closest('[data-nr-accordion]');
      if (!parent) return;
      var expanded = parent.getAttribute('aria-expanded') === 'true';
      parent.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var sub = parent.nextElementSibling;
      if (sub && sub.classList.contains('nr-drawer__sub')) sub.hidden = expanded;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* nutriride: countdown band (sections/nutriride-countdown.liquid)
 *
 * "daily" recomputes the next local midnight on every tick, so the timer rolls
 * over on its own and never sits at 00:00:00. "fixed" stops at zero and hides
 * the clock rather than counting negative.
 */
(function () {
  'use strict';

  function start() {
    var el = document.querySelector('[data-nr-countdown]');
    if (!el) return;

    var mode = el.getAttribute('data-mode') || 'daily';
    var deadlineAttr = (el.getAttribute('data-deadline') || '').trim();
    var hh = el.querySelector('[data-nr-hh]');
    var mm = el.querySelector('[data-nr-mm]');
    var ss = el.querySelector('[data-nr-ss]');
    var clock = el.querySelector('[data-nr-clock]');
    if (!hh || !mm || !ss) return;

    var fixedTarget = null;
    if (mode === 'fixed' && deadlineAttr) {
      var parsed = new Date(deadlineAttr);
      if (!isNaN(parsed.getTime())) fixedTarget = parsed;
    }

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var now = new Date();
      var target;

      if (fixedTarget) {
        target = fixedTarget;
      } else {
        target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      }

      var diff = target.getTime() - now.getTime();

      if (diff <= 0) {
        if (fixedTarget && clock) { clock.style.display = 'none'; return; }
        diff = 0;
      }

      var totalSeconds = Math.floor(diff / 1000);
      hh.textContent = pad(Math.floor(totalSeconds / 3600));
      mm.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      ss.textContent = pad(totalSeconds % 60);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* nutriride: sticky add-to-cart bar (snippets/nutriride-sticky-atc.liquid)
 *
 * Shows once the real buy button scrolls out of view. It forwards clicks to the
 * real button rather than carrying its own form — a duplicate form is how these
 * bars end up adding the wrong variant. Price mirrors the main price element and
 * re-syncs on the theme's own `variant:changed` event (documented at the top of
 * this file by Warehouse).
 */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-nr-sticky]');
    if (!bar) return;

    // Warehouse's add-to-cart is .product-form__add-button, not [name="add"].
    // Scope to a real cart form so the quick-view button is never picked up.
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var realBtn = null;
    for (var i = 0; i < forms.length; i++) {
      var candidate = forms[i].querySelector('.product-form__add-button');
      if (candidate && candidate.offsetParent !== null) { realBtn = candidate; break; }
    }
    if (!realBtn) { bar.remove(); return; }

    var priceEl = bar.querySelector('[data-nr-sticky-price]');
    var compareEl = bar.querySelector('[data-nr-sticky-compare]');
    var variantEl = bar.querySelector('[data-nr-sticky-variant]');
    var stickyBtn = bar.querySelector('[data-nr-sticky-add]');

    // The chat launcher and the gift icon are fixed to the bottom corners, and
    // the chat pill is right where this bar puts Add to cart — on a 1440px
    // screen it covered 76px of a 134px button, and at a z-index of
    // 2,147,483,000 it took the taps too.
    //
    // Published as a length rather than a class so each widget can decide with
    // max() whether the bar is actually above its own resting position. The
    // gift icon sits lower than the chat pill, and on mobile both already
    // clear a tab bar, so one shared "move up by this much" would be wrong for
    // at least one of them.
    //
    // offsetHeight, not getBoundingClientRect: the bar is mid-transform for
    // 240ms after it is shown, and the rect would be measured somewhere in the
    // middle of that slide.
    var docEl = document.documentElement;

    function publishLift() {
      var resting = parseFloat(window.getComputedStyle(bar).bottom) || 0;
      docEl.style.setProperty('--nr-widget-lift', Math.round(resting + bar.offsetHeight + 12) + 'px');
    }

    function clearLift() {
      docEl.style.removeProperty('--nr-widget-lift');
    }

    function show() {
      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'false');
      publishLift();
      requestAnimationFrame(function () { bar.classList.add('is-visible'); });
    }

    function hide() {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      clearLift();
      window.setTimeout(function () {
        if (!bar.classList.contains('is-visible')) bar.hidden = true;
      }, 260);
    }

    // The bar's height changes with the viewport — the thumbnail and the
    // variant line are dropped below 750px — so a rotation or a resize while
    // it is up would leave the widgets parked at the old offset.
    window.addEventListener('resize', function () {
      if (bar.classList.contains('is-visible')) publishLift();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { hide(); } else { show(); } });
      }, { rootMargin: '0px 0px -40px 0px' }).observe(realBtn);
    }

    stickyBtn.addEventListener('click', function () {
      if (realBtn.disabled) return;
      realBtn.click();
    });

    function syncDisabled() {
      stickyBtn.disabled = !!realBtn.disabled;
      stickyBtn.textContent = realBtn.disabled ? 'Sold out' : 'Add to cart';
    }
    syncDisabled();

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;

      var live = document.querySelector('.price-list .price--highlight, .price-list .price');
      if (live && priceEl) priceEl.textContent = live.textContent.replace(/Sale price|Regular price/g, '').trim();

      if (compareEl) {
        var liveCompare = document.querySelector('.price-list .price--compare');
        if (liveCompare && liveCompare.textContent.trim()) {
          compareEl.textContent = liveCompare.textContent.replace(/Regular price/g, '').trim();
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (variantEl && variant.title) variantEl.textContent = variant.title;
      window.setTimeout(syncDisabled, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* nutriride: product gallery arrows
 *
 * The gallery's Flickity instance has no prev/next buttons and Flickity is not
 * exposed globally, so these arrows advance the gallery by clicking the adjacent
 * thumbnail — the theme's own selection path. That keeps zoom, variant-filtered
 * media and the lightbox all working, which a hand-rolled slider would break.
 */
(function () {
  'use strict';

  var ARROW_LEFT  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var ARROW_RIGHT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  function init() {
    var gallery = document.querySelector('.product-gallery');
    if (!gallery) return;

    var wrapper = gallery.querySelector('.product-gallery__carousel-wrapper');
    if (!wrapper || wrapper.querySelector('.nr-gal-arrow')) return;

    function visibleThumbs() {
      return Array.prototype.filter.call(
        gallery.querySelectorAll('.product-gallery__thumbnail'),
        function (t) { return !t.classList.contains('is-filtered') && t.offsetParent !== null; }
      );
    }

    if (visibleThumbs().length < 2) return;

    function make(dir, html, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nr-gal-arrow nr-gal-arrow--' + dir;
      b.innerHTML = html;
      b.setAttribute('aria-label', label);
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var thumbs = visibleThumbs();
        var i = thumbs.findIndex(function (t) { return t.classList.contains('is-nav-selected'); });
        if (i < 0) i = 0;
        var target = dir === 'prev' ? i - 1 : i + 1;
        if (target < 0 || target >= thumbs.length) return;
        thumbs[target].click();
        // the theme repaints the thumbnail state asynchronously
        window.setTimeout(sync, 60);
      });
      return b;
    }

    var prev = make('prev', ARROW_LEFT, 'Previous image');
    var next = make('next', ARROW_RIGHT, 'Next image');
    wrapper.appendChild(prev);
    wrapper.appendChild(next);

    function sync() {
      var thumbs = visibleThumbs();
      var i = thumbs.findIndex(function (t) { return t.classList.contains('is-nav-selected'); });
      if (i < 0) i = 0;
      prev.disabled = i <= 0;
      next.disabled = i >= thumbs.length - 1;
      var only = thumbs.length < 2;
      prev.hidden = only;
      next.hidden = only;
    }
    sync();

    // Variant changes can filter the media set, so re-evaluate bounds
    document.addEventListener('variant:changed', function () { window.setTimeout(sync, 120); });

    new MutationObserver(function () { sync(); })
      .observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* nutriride: gallery share + save (snippets/nutriride-gallery-actions.liquid)
 *
 * Share uses the Web Share API where available and falls back to clipboard.
 *
 * Save is LOCAL-ONLY — see the snippet's comment. Warehouse has no wishlist and
 * no wishlist app is installed on this store, so this persists to localStorage
 * and emits `nutriride:wishlist:changed`. A real app should replace the two
 * storage calls below and listen for that event; the markup needs no change.
 */
(function () {
  'use strict';

  var KEY = 'nutriride:wishlist';

  function read() {
    try { return JSON.parse(window.localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); }
    catch (e) { /* private mode — the UI still reflects the session */ }
  }

  function toast(message) {
    var el = document.querySelector('[data-nr-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    window.clearTimeout(el._t);
    el._t = window.setTimeout(function () {
      el.classList.remove('is-visible');
      window.setTimeout(function () { el.hidden = true; }, 240);
    }, 2200);
  }

  function init() {
    var share = document.querySelector('[data-nr-share]');
    if (share) {
      share.addEventListener('click', function () {
        var url = share.getAttribute('data-share-url');
        var title = share.getAttribute('data-share-title');
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () { /* user dismissed */ });
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url)
            .then(function () { toast('Link copied'); })
            .catch(function () { toast(url); });
        } else {
          toast(url);
        }
      });
    }

    var save = document.querySelector('[data-nr-wishlist]');
    if (save) {
      var handle = save.getAttribute('data-handle');

      function paint() {
        var on = read().indexOf(handle) !== -1;
        save.setAttribute('aria-pressed', on ? 'true' : 'false');
        save.setAttribute('aria-label', on ? 'Remove from saved items' : 'Save for later');
      }
      paint();

      save.addEventListener('click', function () {
        var list = read();
        var i = list.indexOf(handle);
        var added = i === -1;
        if (added) { list.push(handle); } else { list.splice(i, 1); }
        write(list);
        paint();
        toast(added ? 'Saved for later' : 'Removed from saved items');
        document.dispatchEvent(new CustomEvent('nutriride:wishlist:changed', {
          detail: { handle: handle, added: added, list: list }
        }));
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* nutriride: category tabs (sections/nutriride-category-tabs.liquid)
 *
 * Clicking a chip fetches that collection's products through Shopify's Section
 * Rendering API and swaps only the grid:
 *
 *     /collections/<handle>?section_id=<this section id>
 *
 * Rendering the section against a collection URL gives it a real `collection`
 * object, so the same Liquid produces that collection's products. The chips are
 * wrapped in `unless collection`, so the response contains only the body — which
 * is exactly what gets swapped in.
 *
 * Responses are cached per handle, so re-clicking a chip is instant and costs no
 * second request.
 */
(function () {
  'use strict';

  function init() {
    // querySelectorAll, not querySelector: the section can legitimately appear
    // more than once on a page, and a single-root lookup left every instance
    // after the first with dead chips.
    Array.prototype.forEach.call(document.querySelectorAll('[data-nr-cat-tabs]'), setup);
  }

  function setup(root) {
    if (!root) return;

    var body = root.querySelector('[data-nr-cat-body]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-nr-cat-chip]'));
    var sectionId = root.getAttribute('data-section-id');
    if (!body || !chips.length || !sectionId) return;

    var sortBy = root.getAttribute('data-sort-by') || '';

    var cache = {};
    var current = chips[0] ? chips[0].getAttribute('data-handle') : null;

    /* Only cache the server-rendered first tab if it is already in the order
       we are claiming. When Liquid has flagged it for re-sorting, caching it
       here would pin the wrong order for the rest of the session. */
    var needsResort = body.hasAttribute('data-nr-cat-resort');
    if (current && !needsResort) cache[current] = body.innerHTML;

    function setActive(chip) {
      chips.forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function show(html) {
      body.innerHTML = html;
      body.classList.remove('is-loading');
    }

    function load(chip, force) {
      var handle = chip.getAttribute('data-handle');
      var url = chip.getAttribute('data-url') || ('/collections/' + handle);
      if (!handle) return;
      if (handle === current && !force) return;

      current = handle;
      setActive(chip);

      if (cache[handle]) { show(cache[handle]); return; }

      body.classList.add('is-loading');
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      var query = 'section_id=' + encodeURIComponent(sectionId);
      if (sortBy) query += '&sort_by=' + encodeURIComponent(sortBy);

      fetch(url + sep + query, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-nr-cat-body]');
          if (!fresh) throw new Error('no body in response');
          // guard against a slow response landing after the user moved on
          if (current !== handle) return;
          cache[handle] = fresh.innerHTML;
          show(fresh.innerHTML);
        })
        .catch(function () {
          if (current !== handle) return;
          body.classList.remove('is-loading');
          // fall back to the real collection page rather than leaving a dead chip
          window.location.href = url;
        });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { load(chip); });
    });

    /* The first tab's collection does not sort by best selling on its own, so
       what the server rendered is not what this row claims to be. Re-fetch it
       sorted. Only ever reached for that one case — Liquid checks
       `default_sort_by` and omits the flag when the orders already agree. */
    if (needsResort && chips[0]) load(chips[0], true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* nutriride: assurance section (sections/nutriride-assurance.liquid)
 *
 * Two behaviours: expandable fine print, and stats that count up once when
 * scrolled into view. Both degrade safely — without JS the detail stays hidden
 * behind a card that simply does not expand, and the stats show their final
 * value, which is already rendered server-side.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initToggles(root) {
    root.querySelectorAll('[data-nr-assure-toggle]').forEach(function (card) {
      card.addEventListener('click', function () {
        var open = card.getAttribute('aria-expanded') === 'true';
        var detail = card.querySelector('[data-nr-assure-detail]');
        card.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (detail) detail.hidden = open;
      });
    });
  }

  function initCounters(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-nr-count]'));
    if (!els.length) return;

    function run(el) {
      var target = parseFloat(el.getAttribute('data-to'));
      if (isNaN(target)) return;
      var suffix = el.getAttribute('data-suffix') || '';
      var decimals = parseInt(el.getAttribute('data-decimals'), 10) || 0;

      if (reduced) { el.textContent = target.toFixed(decimals) + suffix; return; }

      var start = null, dur = 1100;
      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);          // ease-out cubic
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);                       // count once, not on every scroll past
        run(e.target);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    var root = document.querySelector('[data-nr-assure]');
    if (!root) return;
    initToggles(root);
    initCounters(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   Nutriride — faceted collection filters
   ------------------------------------------------------------
   Progressive enhancement over Warehouse's own filter markup.
   It never touches the checkbox inputs themselves, so the
   theme's delegated `change` listener on [name^="filter."] and
   its Section Rendering reload keep working unchanged.

   Adds, per filter group:
     - counts split out of the label and right-aligned
     - a selected-count badge on the group header
     - "Show all N" collapse past COLLAPSE_AFTER values
     - a type-to-filter search past SEARCH_AFTER values

   Warehouse replaces the filter form's innerHTML on every facet
   change, so this re-runs on `theme:loading:end`.
   ============================================================ */
(function () {
  'use strict';

  var COLLAPSE_AFTER = 8;   // values shown before "Show all N"
  var SEARCH_AFTER = 12;    // values before a search box is worth it
  var DONE = 'nrFiltersDone';

  var SEARCH_ICON =
    '<svg class="nr-filter-search__icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<path d="M7 1a6 6 0 104.24 10.24l3.26 3.26 1.06-1.06-3.26-3.26A6 6 0 007 1zm0 1.5A4.5 4.5 0 112.5 7 4.5 4.5 0 017 2.5z" fill="currentColor"/>' +
    '</svg>';

  /**
   * Split "Whey Protein (24)" into a truncating label and a
   * right-aligned count. Values that would return nothing are
   * kept but dimmed, so the shopper still sees the facet exists.
   */
  function splitCount(row) {
    var label = row.querySelector('label');
    if (!label || label.querySelector('.nr-fv-label')) return;

    var text = (label.textContent || '').trim();
    var match = text.match(/^(.*?)\s*\((\d+)\)$/);
    var name = match ? match[1] : text;
    var count = match ? match[2] : null;

    label.textContent = '';

    var nameEl = document.createElement('span');
    nameEl.className = 'nr-fv-label';
    nameEl.textContent = name;
    label.appendChild(nameEl);

    if (count !== null) {
      var countEl = document.createElement('span');
      countEl.className = 'nr-fv-count';
      countEl.textContent = count;
      label.appendChild(countEl);
      if (count === '0') row.classList.add('is-empty');
    }

    row.setAttribute('data-nr-search', name.toLowerCase());
  }

  /** Number of selections, shown on the header so collapsed groups still read as active. */
  function syncBadge(group) {
    var button = group.querySelector('.collection__filter-group-name');
    if (!button) return;

    var checked = group.querySelectorAll('input[type="checkbox"]:checked').length;
    var badge = button.querySelector('.nr-filter-badge');

    if (!checked) {
      if (badge) badge.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'nr-filter-badge';
      var svg = button.querySelector('svg');
      if (svg) button.insertBefore(badge, svg);
      else button.appendChild(badge);
    }

    badge.textContent = checked;
  }

  /**
   * Decide which rows are visible from the two independent inputs:
   * the search query, and whether the group is expanded past
   * COLLAPSE_AFTER. A search always reaches the whole list.
   */
  function applyVisibility(state) {
    var query = state.input ? state.input.value.trim().toLowerCase() : '';
    var shown = 0;

    state.rows.forEach(function (row) {
      var matches = !query || (row.getAttribute('data-nr-search') || '').indexOf(query) !== -1;
      var withinCap = query ? true : state.expanded || shown < COLLAPSE_AFTER;
      var visible = matches && withinCap;

      row.classList.toggle('nr-is-hidden', !visible);
      if (matches) shown++;
    });

    if (state.more) {
      // The collapse toggle is meaningless while a search is narrowing the list.
      state.more.hidden = !!query || state.rows.length <= COLLAPSE_AFTER;
      state.more.textContent = state.expanded
        ? 'Show less'
        : 'Show all ' + state.rows.length;
    }

    if (state.empty) state.empty.hidden = shown !== 0;

    // Only cap the height once the full list is on screen.
    state.list.classList.toggle('nr-filter-scroll', state.expanded || !!query);
  }

  function enhanceGroup(group) {
    var list = group.querySelector('.collection__filter-checkbox-list');
    if (!list) return; // boolean filters, price range, swatches

    var rows = Array.prototype.slice.call(
      list.querySelectorAll('.collection__filter-checkbox')
    );
    rows.forEach(splitCount);
    syncBadge(group);

    if (rows.length <= COLLAPSE_AFTER) return;

    var state = { group: group, list: list, rows: rows, expanded: false, input: null, more: null, empty: null };

    if (rows.length > SEARCH_AFTER) {
      var labelText = (group.querySelector('.collection__filter-group-name') || {}).textContent || '';
      labelText = labelText.replace(/\d+$/, '').trim().toLowerCase();

      var wrap = document.createElement('div');
      wrap.className = 'nr-filter-search';
      wrap.innerHTML = SEARCH_ICON;

      var input = document.createElement('input');
      input.type = 'text';
      input.className = 'nr-filter-search__field';
      input.placeholder = 'Search ' + (labelText || 'options');
      input.setAttribute('autocomplete', 'off');
      // Deliberately unnamed: the theme listens on [name^="filter."] and
      // serialises this form, so a named field would both trigger a reload
      // and leak into the facet URL.
      wrap.appendChild(input);
      list.parentNode.insertBefore(wrap, list);

      input.addEventListener('input', function () { applyVisibility(state); });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') event.preventDefault(); // never submit the filter form
      });

      state.input = input;
    }

    var empty = document.createElement('p');
    empty.className = 'nr-filter-empty';
    empty.textContent = 'No matches';
    empty.hidden = true;
    list.parentNode.insertBefore(empty, list.nextSibling);
    state.empty = empty;

    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'nr-filter-more';
    list.parentNode.insertBefore(more, empty.nextSibling);
    state.more = more;

    more.addEventListener('click', function () {
      state.expanded = !state.expanded;
      applyVisibility(state);
      resizeCollapsible(group);
    });

    applyVisibility(state);
  }

  /**
   * The theme's collapsible pins an inline pixel height when a group is
   * open. Revealing rows inside it has to re-measure, or the extra rows
   * are clipped.
   */
  function resizeCollapsible(group) {
    var panel = group.querySelector('.collection__filter-collapsible');
    if (!panel || panel.getAttribute('aria-hidden') === 'true') return;
    panel.style.height = 'auto';
  }

  function run() {
    var groups = document.querySelectorAll('.collection__filter-group');

    Array.prototype.forEach.call(groups, function (group) {
      if (group.dataset[DONE]) {
        syncBadge(group); // markup survived; selections may not have
        return;
      }
      group.dataset[DONE] = '1';
      enhanceGroup(group);
    });
  }

  function schedule() {
    window.requestAnimationFrame(run);
  }

  document.addEventListener('theme:loading:end', schedule);
  document.addEventListener('shopify:section:load', schedule);
  // Fired by nutriride-facets.js after it rebuilds counts.
  document.addEventListener('nr:filters:refresh', schedule);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* ============================================================
   Nutriride — sticky offset for the collection sidebar
   ------------------------------------------------------------
   The filter panel is position:sticky, but the theme's header is
   sticky too and 84px tall, so pinning the panel at a fixed 16px
   put its own "Filters" title 68px behind the header.

   The right offset is not a constant: the header group holds the
   announcement bar as well, and only part of it stays pinned once
   you scroll. So measure whatever is actually pinned right now —
   anything sticky/fixed whose top has reached the viewport edge —
   and publish the result as --nr-sticky-offset.
   ============================================================ */
(function () {
  'use strict';

  if (!document.body || !document.body.classList.contains('template-collection')) return;

  var GAP = 12;        // breathing room between header and panel
  var MAX = 180;       // never push the panel absurdly far down
  var last = null;

  function pinnedBottom() {
    var bottom = 0;
    var candidates = document.querySelectorAll(
      '.shopify-section-group-header-group, .shopify-section--header, .announcement-bar'
    );

    Array.prototype.forEach.call(candidates, function (el) {
      var position = window.getComputedStyle(el).position;
      if (position !== 'sticky' && position !== 'fixed') return;

      var rect = el.getBoundingClientRect();
      // Only count what is currently pinned to the top. An element still at
      // its natural position further down the page is about to scroll away
      // and must not inflate the offset.
      if (rect.height > 0 && rect.top <= 1 && rect.bottom > bottom) bottom = rect.bottom;
    });

    return bottom;
  }

  function sync() {
    var offset = Math.round(pinnedBottom());
    offset = offset > 0 ? Math.min(offset + GAP, MAX) : 16;
    if (offset === last) return;
    last = offset;
    document.documentElement.style.setProperty('--nr-sticky-offset', offset + 'px');
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; sync(); });
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  sync();
})();

/* ============================================================
   Nutriride — horizontal rail arrows
   ------------------------------------------------------------
   Drives any [data-nr-rail] with a matching [data-nr-rail-nav].
   The arrows stay hidden unless the rail actually overflows, so
   a short list does not get dead controls, and each is disabled
   at its end of the track.
   ============================================================ */
(function () {
  'use strict';

  function setup(rail) {
    var scope = rail.closest('section') || document;
    var nav = scope.querySelector('[data-nr-rail-nav]');
    var prev = scope.querySelector('[data-nr-rail-prev]');
    var next = scope.querySelector('[data-nr-rail-next]');
    if (!nav || !prev || !next) return;

    function step() {
      // Advance by whole cards where possible, and never by more than
      // the visible width.
      var card = rail.firstElementChild;
      var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 14;
      var one = card ? card.getBoundingClientRect().width + gap : 240;
      var fit = Math.max(1, Math.floor(rail.clientWidth / one));
      return Math.min(one * fit, rail.clientWidth);
    }

    function sync() {
      var overflows = rail.scrollWidth - rail.clientWidth > 4;
      nav.hidden = !overflows;
      if (!overflows) return;
      var max = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

    var queued = false;
    rail.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; sync(); });
    }, { passive: true });

    window.addEventListener('resize', sync);

    // Card images load late and change scrollWidth, so re-measure once
    // the section has settled rather than only on first paint.
    sync();
    window.setTimeout(sync, 600);
    if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nr-rail]'), function (rail) {
      if (rail.dataset.nrRailReady) return;
      rail.dataset.nrRailReady = '1';
      setup(rail);
    });
  }

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   Nutriride — saved items (wishlist) surface
   ------------------------------------------------------------
   The product page already wrote handles to localStorage, but
   there was no header entry point and no page, so a customer
   could save something and never see it again. This adds both.

   Cards are fetched from
   /products/<handle>?section_id=nutriride-wishlist-card, which
   returns the real Liquid card — labels, rating, cheapest
   in-stock price — rather than a JS rebuild of one. Verified:
   that request returns a full .product-item on a product URL.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'nutriride:wishlist';
  var CONCURRENCY = 4;

  function read() {
    try { return JSON.parse(window.localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  /* ---- header badge ---- */

  function paintCount() {
    var n = read().length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-nr-wishlist-count]'), function (el) {
      el.textContent = n > 99 ? '99+' : n;
      el.hidden = n === 0;
    });
  }

  /* ---- the page ---- */

  function card(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=nutriride-wishlist-card',
                 { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('.product-item');
      })
      .catch(function () { return null; });
  }

  function renderPage() {
    var page = document.querySelector('[data-nr-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-nr-wishlist-grid]');
    var empty = page.querySelector('[data-nr-wishlist-empty]');
    var loading = page.querySelector('[data-nr-wishlist-loading]');
    var summary = page.querySelector('[data-nr-wishlist-summary]');
    var clear = page.querySelector('[data-nr-wishlist-clear]');

    var list = read();

    function finish(rendered) {
      loading.hidden = true;
      var n = rendered.length;
      empty.hidden = n > 0;
      clear.hidden = n === 0;
      summary.textContent = n ? n + (n === 1 ? ' item' : ' items') : '';
      paintCount();
    }

    grid.innerHTML = '';
    if (!list.length) { finish([]); return; }

    loading.hidden = false;

    // Fetch in parallel but place by index, so the grid keeps the order the
    // customer saved things in rather than whichever request won.
    var slots = new Array(list.length);
    var queue = list.map(function (h, i) { return { h: h, i: i }; });

    function worker() {
      if (!queue.length) return Promise.resolve();
      var job = queue.shift();
      return card(job.h).then(function (el) {
        slots[job.i] = el ? { el: el, handle: job.h } : null;
      }).then(worker);
    }

    var workers = [];
    for (var i = 0; i < CONCURRENCY; i++) workers.push(worker());

    Promise.all(workers).then(function () {
      var kept = [];
      slots.forEach(function (s) {
        if (!s) return;
        kept.push(s.handle);

        var wrap = document.createElement('div');
        wrap.className = 'nr-wishlist__item';
        wrap.appendChild(s.el);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'nr-wishlist__remove';
        remove.setAttribute('aria-label', 'Remove from saved items');
        remove.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.7" fill="none" stroke-linecap="round"/></svg>';
        remove.addEventListener('click', function () {
          var cur = read();
          var at = cur.indexOf(s.handle);
          if (at >= 0) { cur.splice(at, 1); write(cur); }
          wrap.remove();
          document.dispatchEvent(new CustomEvent('nutriride:wishlist:changed',
            { detail: { handle: s.handle, added: false, list: read() } }));
          var left = grid.querySelectorAll('.nr-wishlist__item').length;
          finish(new Array(left));
        });
        wrap.appendChild(remove);
        grid.appendChild(wrap);
      });

      // A product that has since been deleted or unpublished returns nothing.
      // Drop it from storage rather than leaving a handle that never renders.
      if (kept.length !== list.length) write(kept);

      finish(kept);
    });

    if (clear && !clear.dataset.bound) {
      clear.dataset.bound = '1';
      clear.addEventListener('click', function () {
        write([]);
        grid.innerHTML = '';
        finish([]);
        document.dispatchEvent(new CustomEvent('nutriride:wishlist:changed',
          { detail: { cleared: true, list: [] } }));
      });
    }
  }

  function init() { paintCount(); renderPage(); }

  document.addEventListener('nutriride:wishlist:changed', paintCount);
  // Keep the badge honest when the list changes in another tab.
  window.addEventListener('storage', function (e) { if (e.key === KEY) paintCount(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   Nutriride — header category picker
   ------------------------------------------------------------
   Replaces Warehouse's product_type select. Selecting a category
   scopes to that collection; submitting with a term lands on the
   collection with ?nf_q=<term>, which the facet engine applies
   as a title filter. That gives real search-within-category,
   where product_type scoping returned 0 results for whole
   categories because half the catalogue has no type set.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-nr-catpick]');
  if (!root) return;

  var toggle = root.querySelector('[data-nr-catpick-toggle]');
  var panel = root.querySelector('[data-nr-catpick-panel]');
  var label = root.querySelector('[data-nr-catpick-label]');
  var form = root.closest('form');
  var chosen = { handle: '', url: '' };

  /**
   * "All categories" does not fit beside the input and the submit button on a
   * narrow phone, and clipping it mid-word read as "All catego...". Narrow
   * screens get the short form instead.
   */
  function setLabel(opt) {
    var full = opt.getAttribute('data-label') || opt.textContent.trim();
    var short = opt.getAttribute('data-short');
    label.textContent = (short && window.innerWidth <= 430) ? short : full;
  }

  function currentOption() {
    return panel.querySelector('.nr-catpick__option.is-selected') ||
           panel.querySelector('.nr-catpick__option');
  }

  function open(on) {
    panel.hidden = !on;
    root.classList.toggle('is-open', on);
    toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    open(panel.hidden);
  });

  panel.addEventListener('click', function (e) {
    var opt = e.target.closest('.nr-catpick__option');
    if (!opt) return;
    e.preventDefault();
    e.stopPropagation();

    Array.prototype.forEach.call(panel.querySelectorAll('.nr-catpick__option'), function (o) {
      var sel = o === opt;
      o.classList.toggle('is-selected', sel);
      o.setAttribute('aria-selected', sel ? 'true' : 'false');
    });

    chosen = { handle: opt.getAttribute('data-handle') || '', url: opt.getAttribute('data-url') || '' };
    setLabel(opt);
    root.classList.toggle('has-selection', !!chosen.handle);
    open(false);
  });

  document.addEventListener('click', function (e) {
    if (!panel.hidden && !root.contains(e.target)) open(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) { open(false); toggle.focus(); }
  });

  window.addEventListener('resize', function () { setLabel(currentOption()); });
  setLabel(currentOption());

  // Capture phase: Warehouse also listens for submit on this form and would
  // otherwise run its own search first.
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!chosen.handle || !chosen.url) return;   // "All categories" — leave it alone
      var input = form.querySelector('[name="q"]');
      var term = input ? input.value.trim() : '';
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = chosen.url + (term ? '?nf_q=' + encodeURIComponent(term) : '');
    }, true);
  }
})();

/* ============================================================
   Nutriride — keep the mobile search row inside the nav
   ------------------------------------------------------------
   On phones the search sits on a second flex line of
   .header__inner, but that container's box stays one row tall
   while its content is taller, so the search spills below the
   header's background. Nothing in CSS would make it grow (tried
   height:auto on the inner and the container, align-items:
   stretch on the header, and a Grid rebuild), so the background
   is extended over the spill instead.

   Measured here rather than hard-coded: the row's height changes
   with the announcement bar, the logo size and the font.
   ============================================================ */
(function () {
  'use strict';

  var MAX = 160;   // never paint further than a plausible search row

  function sync() {
    var header = document.querySelector('.header');
    var search = document.querySelector('.header__search-bar-wrapper');
    if (!header || !search) return;

    var root = document.documentElement;

    if (window.innerWidth > 749) {
      root.style.setProperty('--nr-header-extend', '0px');
      return;
    }

    var spill = Math.ceil(search.getBoundingClientRect().bottom - header.getBoundingClientRect().bottom);
    var extend = spill > 0 ? Math.min(spill + 10, MAX) : 0;
    root.style.setProperty('--nr-header-extend', extend + 'px');
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; sync(); });
  }

  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);
  // Re-measure once webfonts land, since they change the row's height.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
  window.addEventListener('load', sync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();

/* ============================================================
   Nutriride — quick add from the product card
   ------------------------------------------------------------
   Nutrabay's pattern: a "+" on the card opens a sheet where you
   pick flavour and size and add to the cart without opening the
   product page.

   Warehouse cannot do this. Its quick view carries `hidden-phone`
   and `_openQuickView` redirects to the product page whenever the
   viewport matches phone or tablet, and a multi-variant card's
   button is only a "Choose options" link. So this is built here.

   Data comes from /products/<handle>.js, which carries every
   variant's price, compare-at price and availability, so prices
   in the sheet are live rather than baked into the grid.

   On success it dispatches `cart:refresh`, which Warehouse's
   mini-cart already listens for at document level, so the header
   count and drawer update without a reload.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-nr-qadd-root]');
  if (!root) return;

  var panel = root.querySelector('.nr-qadd__panel');
  var body = root.querySelector('[data-nr-qadd-body]');
  var thumb = root.querySelector('[data-nr-qadd-thumb]');
  var titleEl = root.querySelector('[data-nr-qadd-link]');
  var detailsEl = root.querySelector('[data-nr-qadd-details]');
  var submit = root.querySelector('[data-nr-qadd-submit]');
  var note = root.querySelector('[data-nr-qadd-note]');

  var cache = {};
  var state = { product: null, chosen: {}, variant: null, lastTrigger: null };

  function money(cents) {
    // Matches the store's own format: ₹ 1,499 with no decimals.
    var n = Math.round(cents / 100);
    return '₹ ' + n.toLocaleString('en-IN');
  }

  /* ---- open / close ---- */

  function open() {
    root.hidden = false;
    document.body.classList.add('nr-qadd-open');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
  }

  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('nr-qadd-open');
    window.setTimeout(function () { root.hidden = true; }, 240);
    if (state.lastTrigger) state.lastTrigger.focus();
  }

  root.querySelector('[data-nr-qadd-scrim]').addEventListener('click', close);
  root.querySelector('[data-nr-qadd-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  /* ---- variant resolution ---- */

  /** Every option name, in position order, as /products/x.js reports them. */
  function optionNames(p) {
    return (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  }

  /** Variants matching the current partial selection. */
  function candidates(p, chosen, ignoreName) {
    var names = optionNames(p);
    return p.variants.filter(function (v) {
      for (var i = 0; i < names.length; i++) {
        var name = names[i];
        if (name === ignoreName) continue;
        var want = chosen[name];
        if (want != null && v.options[i] !== want) return false;
      }
      return true;
    });
  }

  function resolve(p, chosen) {
    var names = optionNames(p);
    var full = names.every(function (n) { return chosen[n] != null; });
    if (!full) return null;
    return p.variants.find(function (v) {
      return names.every(function (n, i) { return v.options[i] === chosen[n]; });
    }) || null;
  }

  /* ---- rendering ---- */

  function render() {
    var p = state.product;
    var names = optionNames(p);
    body.innerHTML = '';

    names.forEach(function (name) {
      var group = document.createElement('div');
      group.className = 'nr-qadd__group';

      var label = document.createElement('p');
      label.className = 'nr-qadd__group-label';
      label.textContent = name;
      group.appendChild(label);

      var values = [];
      p.variants.forEach(function (v) {
        var val = v.options[names.indexOf(name)];
        if (val && values.indexOf(val) < 0) values.push(val);
      });

      // Size-like options get the richer card treatment (price, saving);
      // flavour-like options stay compact chips, as on nutrabay.
      var isSize = /size|weight|strength|pack/i.test(name);
      var list = document.createElement('div');
      list.className = isSize ? 'nr-qadd__cards' : 'nr-qadd__chips';

      values.forEach(function (val) {
        var pool = candidates(p, state.chosen, name).filter(function (v) {
          return v.options[names.indexOf(name)] === val;
        });
        // Purchasable with what is currently chosen...
        var buyable = pool.filter(function (v) { return v.available; });
        // ...versus purchasable at all, in any combination. Only the second
        // means sold out; the first just means another option has to move,
        // which clicking now does.
        var anywhere = p.variants.filter(function (v) {
          return v.options[names.indexOf(name)] === val && v.available;
        });
        var soldOut = anywhere.length === 0;
        var usable = buyable.length ? buyable : pool;
        var cheapest = usable.sort(function (a, b) { return a.price - b.price; })[0];

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = isSize ? 'nr-qadd__card' : 'nr-qadd__chip';
        if (state.chosen[name] === val) btn.classList.add('is-selected');
        if (soldOut) btn.classList.add('is-unavailable');
        else if (!buyable.length) btn.classList.add('is-switch');

        if (isSize && cheapest) {
          var off = cheapest.compare_at_price && cheapest.compare_at_price > cheapest.price
            ? Math.round((cheapest.compare_at_price - cheapest.price) / cheapest.compare_at_price * 100) : 0;
          btn.innerHTML =
            '<span class="nr-qadd__card-size">' + val + '</span>' +
            '<span class="nr-qadd__card-price">' + money(cheapest.price) + '</span>' +
            (off >= 10
              ? '<span class="nr-qadd__card-off">' + off + '% off &middot; save ' +
                money(cheapest.compare_at_price - cheapest.price) + '</span>'
              : '') +
            (soldOut ? '<span class="nr-qadd__card-out">Sold out</span>' : '');
        } else {
          btn.textContent = val;
        }

        btn.addEventListener('click', function () {
          if (soldOut) return;
          chooseWith(p, name, val);
          sync();
        });

        list.appendChild(btn);
      });

      group.appendChild(list);
      body.appendChild(group);
    });
  }

  function sync() {
    render();
    var v = resolve(state.product, state.chosen);
    state.variant = v;

    var names = optionNames(state.product);
    var missing = names.filter(function (n) { return state.chosen[n] == null; });

    if (missing.length) {
      submit.disabled = true;
      note.textContent = 'Choose ' + missing.join(' and ').toLowerCase();
    } else if (!v) {
      submit.disabled = true;
      note.textContent = 'That combination is not available.';
    } else if (!v.available) {
      submit.disabled = true;
      note.textContent = 'This option is sold out.';
    } else {
      submit.disabled = false;
      note.textContent = money(v.price) + (v.compare_at_price > v.price ? ' · was ' + money(v.compare_at_price) : '');
    }

    if (v) detailsEl.href = '/products/' + state.product.handle + '?variant=' + v.id;
  }

  /* ---- loading ---- */

  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) cache[handle] = p; return p; });
  }

  /* How many option values stay selectable from a given variant: for each
   * option, the number of distinct values still reachable once the other
   * options are fixed to that variant's. Used to open the sheet somewhere
   * useful, and to pick the least disruptive switch when a chosen value forces
   * another option to change.
   */
  function reachScore(names, pool, v) {
    var total = 0;
    names.forEach(function (name, i) {
      var seen = {};
      pool.forEach(function (c) {
        var matchesOthers = names.every(function (other, j) {
          return j === i || c.options[j] === v.options[j];
        });
        if (matchesOthers) seen[c.options[i]] = true;
      });
      total += Object.keys(seen).length;
    });
    return total;
  }

  /* Choosing a value that does not fit the current selection moves the other
   * options instead of refusing.
   *
   * "5 servings" exists in exactly one variant, flavour "5 Flavours". With any
   * real flavour selected it had no matching variant, so it rendered struck
   * through and did nothing when clicked — a size that is genuinely in stock
   * and could not be bought from this sheet. The reverse held too: picking that
   * size struck out all eighteen flavours.
   *
   * Now the clicked value is kept, as much of the rest of the selection as
   * still works is kept with it, and anything left over is re-picked from the
   * variants that actually carry the clicked value — preferring purchasable
   * ones, then the widest reach, then the cheapest.
   */
  function chooseWith(p, name, val) {
    var names = optionNames(p);
    var i = names.indexOf(name);

    var pool = p.variants.filter(function (v) { return v.options[i] === val && v.available; });
    if (!pool.length) pool = p.variants.filter(function (v) { return v.options[i] === val; });
    if (!pool.length) return;

    // Prefer variants that also honour what is already chosen.
    var keep = pool.filter(function (v) {
      return names.every(function (n, j) {
        return j === i || state.chosen[n] == null || v.options[j] === state.chosen[n];
      });
    });
    var from = keep.length ? keep : pool;

    var pick = from.slice().sort(function (a, b) {
      var d = reachScore(names, pool, b) - reachScore(names, pool, a);
      return d !== 0 ? d : a.price - b.price;
    })[0];

    names.forEach(function (n, j) { state.chosen[n] = pick.options[j]; });
  }

  function preselect(p) {
    var names = optionNames(p);
    state.chosen = {};

    var pool = p.variants.filter(function (v) { return v.available; });
    if (!pool.length) pool = p.variants.slice();

    /* Open on the variant that leaves the most choices open, not the cheapest.
     *
     * Cheapest-first was chosen so the sheet agreed with the "From ₹…" on the
     * card. On One Science Whey Protein that landed on the ₹599 sample: Size
     * "5 servings" has exactly one variant, Flavor "5 Flavours", so every real
     * flavour correctly rendered as unavailable and a product with 34 in-stock
     * variants opened looking sold out.
     *
     * `reach` counts how many option values would actually be selectable from a
     * given starting variant — for each option, how many distinct values are
     * still available once the other options are fixed to that variant's. The
     * sample pack scores 2; a 1Kg flavour scores about 16. Price only breaks
     * ties, so the sheet still opens cheap where that costs nothing.
     */
    var start = pool.slice().sort(function (a, b) {
      var d = reachScore(names, pool, b) - reachScore(names, pool, a);
      return d !== 0 ? d : a.price - b.price;
    })[0];

    if (start) names.forEach(function (n, i) { state.chosen[n] = start.options[i]; });
  }

  /* ---- add to cart ---- */

  function flash(message, ok) {
    note.textContent = message;
    note.classList.toggle('is-ok', !!ok);
    note.classList.toggle('is-error', !ok);
    window.setTimeout(function () {
      note.classList.remove('is-ok', 'is-error');
    }, 2600);
  }

  function addToCart(id, trigger) {
    var label = submit.textContent;
    submit.disabled = true;
    submit.textContent = 'Adding…';

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        submit.textContent = label;
        if (!res.ok) {
          flash(res.data && res.data.description ? res.data.description : 'Could not add that.', false);
          submit.disabled = false;
          return;
        }
        flash('Added to cart', true);
        // Warehouse's mini-cart listens for this at document level.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        refreshCount();
        window.setTimeout(close, 900);
      })
      .catch(function () {
        submit.textContent = label;
        submit.disabled = false;
        flash('Network error. Try again.', false);
      });
  }

  function refreshCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = n; });
        document.querySelectorAll('[data-nr-tabbar-cart]').forEach(function (el) {
          el.textContent = n; el.hidden = n === 0;
        });
      })
      .catch(function () {});
  }

  submit.addEventListener('click', function () {
    if (state.variant) addToCart(state.variant.id);
  });

  /* ---- the trigger ---- */

  /* Warm the cache before the click. Pointer-enter covers desktop; touchstart
     fires roughly 100ms before the click on a tap, which is most of the round
     trip. Both are cheap — `load` returns the cached copy on every later call. */
  function prefetch(event) {
    var t = event.target.closest && event.target.closest('[data-nr-qadd]');
    if (!t || t.getAttribute('data-single')) return;
    var h = t.getAttribute('data-handle');
    if (h) load(h).catch(function () {});
  }
  document.addEventListener('pointerenter', prefetch, true);
  document.addEventListener('touchstart', prefetch, { capture: true, passive: true });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-nr-qadd]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();          // the whole card is a link
    state.lastTrigger = trigger;

    var single = trigger.getAttribute('data-single');
    if (single) {
      // One variant: no decision to make, so skip the sheet entirely.
      trigger.classList.add('is-busy');
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(single), quantity: 1 }] })
      }).then(function () {
        trigger.classList.remove('is-busy');
        trigger.classList.add('is-done');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        refreshCount();
        window.setTimeout(function () { trigger.classList.remove('is-done'); }, 1600);
      }).catch(function () { trigger.classList.remove('is-busy'); });
      return;
    }

    var handle = trigger.getAttribute('data-handle');

    /* The sheet is filled BEFORE it opens.

       It used to open immediately on a "Loading options…" spinner and fill
       when /products/<handle>.js returned. Measured at 420px: the panel
       animated in at 274px tall, then at ~120ms jumped to 659px — and because
       it is anchored to the bottom of the screen, its top edge leapt 392px
       upward while the slide-in was still running. That lurch is the glitch.

       Building first costs the round trip before anything appears, which is
       why the trigger takes a busy state and why hovering or touching a "+"
       prefetches the product into the same cache. With the cache warm the
       sheet opens on the next frame. */
    trigger.classList.add('is-busy');

    var fill = function (p) {
      trigger.classList.remove('is-busy');
      titleEl.textContent = trigger.getAttribute('data-title') || '';
      titleEl.href = '/products/' + handle;
      detailsEl.href = '/products/' + handle;
      thumb.innerHTML = '';
      note.textContent = '';

      if (!p) {
        body.innerHTML = '<p class="nr-qadd__error">Could not load options.</p>';
        submit.disabled = true;
        open();
        return;
      }

      state.product = p;
      if (p.featured_image) {
        var img = document.createElement('img');
        img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
        img.alt = '';
        thumb.appendChild(img);
      }
      preselect(p);
      sync();      // renders the body and sets the submit state
      open();      // only once the panel is its final height
    };

    load(handle).then(fill).catch(function () { fill(null); });
  }, true);
})();

/* ---------------------------------------------------------------------------
 * Nutriride — keep the product title in step with the selected variant
 *
 * The <h1> is rendered as the base title plus a span holding the selected
 * variant's option values ("- Rich Chocolate - 5Lb"). Switching flavour or
 * size has to rewrite that span, or the heading contradicts the swatches.
 *
 * `variant.title` is already the option values joined with " / ", so it is
 * used directly rather than re-reading option1/2/3 — that also keeps the
 * order the product itself uses, which is not consistent across the
 * catalogue. Values already in the base title are dropped, same rule as the
 * Liquid, so "... 5Lb" never becomes "... 5Lb - 5Lb".
 * ------------------------------------------------------------------------- */
(function () {
  var heading = document.querySelector('[data-nr-title]');
  if (!heading) return;

  var span = heading.querySelector('[data-nr-title-variant]');
  if (!span) return;

  // The base title is whatever sits before the span, fixed at load.
  var base = '';
  Array.prototype.forEach.call(heading.childNodes, function (n) {
    if (n !== span) base += n.textContent;
  });
  base = base.trim();
  var baseLower = base.toLowerCase();

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) {
      span.textContent = '';
      return;
    }

    var values = String(variant.title || '').split(' / ');
    var suffix = '';

    values.forEach(function (v) {
      v = v.trim();
      if (!v || v === 'Default Title') return;
      if (baseLower.indexOf(v.toLowerCase()) !== -1) return;
      suffix += ' - ' + v;
    });

    span.textContent = suffix;
  });
})();

/* ---------------------------------------------------------------------------
 * Nutriride — keep the free gifts honest
 *
 * Three rules, in order: a cart with no paid items keeps no gifts; the same
 * gift never appears on two lines; no gift line exceeds quantity 1.
 *
 * The cart-value offers come from the AppHero Free Gift app, which adds a ₹0
 * line item once the cart clears a threshold. The app does not lock that line,
 * so without this a customer can set the free shaker to quantity 5 and the
 * store ships five of them. The old Kalles theme carried the same guard; this
 * is that logic, ported.
 *
 * Matched on price === 0 rather than on the two product titles, so a third
 * gift added in the app later is covered without a code change. A ₹0 line can
 * only reach the cart through the gift app — nothing in the catalogue is free.
 *
 * Since the cart templates now render gift lines with a static quantity and
 * no Remove control, this no longer fires in normal use — it is the backstop
 * for quantities set outside the theme's own controls (a direct
 * /cart/change.js call, or the gift app adding a line at quantity > 1).
 *
 * Event-driven rather than the old theme's 1.5s setInterval, which ran on
 * every page for the whole session.
 * ------------------------------------------------------------------------- */
(function () {
  var busy = false;

  /* One violation is fixed per pass, then the cart is re-read.
   *
   * /cart/change.js re-keys every remaining line on each call, so a list of
   * keys gathered up front goes stale the moment the first change lands. Doing
   * one change and re-reading is slower than a batch but it cannot act on a
   * stale key — which, on a cart line, means changing the wrong product.
   */
  function findViolation(cart) {
    var gifts = [];
    var paid = 0;
    var i;

    for (i = 0; i < cart.items.length; i++) {
      if (cart.items[i].price === 0) gifts.push(cart.items[i]);
      else paid += 1;
    }

    if (!gifts.length) return null;

    /* The cart no longer qualifies for anything.
     *
     * The gift app adds its line when the cart crosses a threshold but does not
     * take it back when the qualifying product is removed, so the cart could end
     * up holding nothing but free items. Checkout would then be a ₹0 order.
     *
     * Only the no-paid-items case is handled here, because it is the only one
     * the theme can judge. Per-product rules ("buy this gainer, get that vest")
     * live in the app and are not exposed to the storefront — see the register.
     */
    if (paid === 0) {
      return { reason: 'cart has no paid items', key: gifts[0].key, quantity: 0 };
    }

    /* The same gift on two lines.
     *
     * Shopify keys a cart line by variant *plus* properties, so the app's own
     * line (carrying _apphero_gift) and a bare line of the same variant never
     * merge — they show as two free gifts. Keep the app's line where there is
     * one, since removing that is what makes the app add it back.
     */
    var seen = {};
    for (i = 0; i < gifts.length; i++) {
      var vid = gifts[i].variant_id;
      if (seen[vid] === undefined) {
        seen[vid] = i;
        continue;
      }
      var keptIsApp = gifts[seen[vid]].properties && gifts[seen[vid]].properties._apphero_gift;
      var dropIndex = keptIsApp ? i : seen[vid];
      if (!keptIsApp) seen[vid] = i;
      return { reason: 'duplicate gift line', key: gifts[dropIndex].key, quantity: 0 };
    }

    for (i = 0; i < gifts.length; i++) {
      if (gifts[i].quantity > 1) {
        return { reason: 'gift quantity above 1', key: gifts[i].key, quantity: 1 };
      }
    }

    return null;
  }

  function enforce() {
    if (busy) return;
    busy = true;

    var passes = 0;

    function pass() {
      if (passes++ > 8) return null;          // never loop on an unfixable cart

      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return null;

          var fix = findViolation(cart);
          if (!fix) return passes > 1
            ? document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
            : null;

          return fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: fix.key, quantity: fix.quantity })
          }).then(pass);
        });
    }

    pass()
      .catch(function () { /* leave the cart alone if anything fails */ })
      .then(function () { busy = false; });
  }

  var timer = null;
  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(enforce, 400);
  }

  /* The cart page interceptor hands us the cart it just received, so the common
     case — a change that breaks none of the three rules — costs no request at
     all. Only an actual violation falls through to the fetch-and-fix loop. */
  document.addEventListener('nr:cart:changed', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart && cart.items && !findViolation(cart)) return;
    schedule();
  });

  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:added', schedule);

  // The app adds its gift without firing a theme event, so a cart-page or
  // drawer interaction is also a cue to re-check.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    /* On the cart page the quantity controls are intercepted and already report
       through nr:cart:changed, so reacting to the click as well just doubles
       the work. */
    if (e.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]')) return;
    if (e.target.closest('.line-item, .cart-drawer, [name="checkout"], [data-action*="cart"]')) schedule();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();

/* ---------------------------------------------------------------------------
 * Nutriride — banner carousel
 *
 * Progressive enhancement over a scroll-snap track: the track already swipes
 * and scrolls without this. This adds autoplay, arrows and dots.
 *
 * Autoplay stops for good on any real interaction — swipe, arrow, dot or
 * keyboard. A carousel that keeps moving after someone has taken hold of it
 * takes the page away from them.
 * ------------------------------------------------------------------------- */
(function () {
  var roots = document.querySelectorAll('[data-nr-bnr-carousel]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root) {
    var track = root.querySelector('[data-nr-bnr-track]');
    var prev  = root.querySelector('[data-nr-bnr-prev]');
    var next  = root.querySelector('[data-nr-bnr-next]');
    var status = root.querySelector('[data-nr-bnr-status]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.nr-bnr__slot'));
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var stopped = false;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = (parseInt(root.getAttribute('data-speed'), 10) || 5) * 1000;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-nr-bnr-dot]'));

    // The live region reports position to a screen reader; the dots report it
    // to everyone else. Both are driven from here so they cannot disagree.
    function paint() {
      if (status) status.textContent = 'Banner ' + (index + 1) + ' of ' + slides.length;
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stop();          // a tap on a dot is a real interaction; stop autoplay
        goTo(i);
      });
    });

    function goTo(i, smooth) {
      // Wrapping last-to-first animates the full width of the track — on three
      // 1200px slides that is a 2400px rewind, which reads as a glitch rather
      // than a transition. Wrap instantly; step smoothly.
      var wrapped = i < 0 || i >= slides.length;
      index = (i + slides.length) % slides.length;
      track.scrollTo({
        left: slides[index].offsetLeft - slides[0].offsetLeft,
        behavior: (smooth === false || reduced || wrapped) ? 'auto' : 'smooth'
      });
      paint();
    }

    // Which slide is actually in view — the scroll position is the source of
    // truth, because a swipe moves it without going through goTo().
    function syncFromScroll() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft - track.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      if (best !== index) { index = best; paint(); }
    }

    function stop() {
      stopped = true;
      window.clearInterval(timer);
      timer = null;
    }

    function start() {
      if (!autoplay || stopped || reduced || slides.length < 2) return;
      window.clearInterval(timer);
      timer = window.setInterval(function () {
        if (document.hidden) return;
        goTo(index + 1);
      }, speed);
    }

    if (prev) prev.addEventListener('click', function () { stop(); goTo(index - 1); });
    if (next) next.addEventListener('click', function () { stop(); goTo(index + 1); });
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(syncFromScroll, 90);
    }, { passive: true });

    // A swipe or a drag is a real interaction; a programmatic scroll is not,
    // so autoplay is only cancelled by pointer and key events.
    track.addEventListener('pointerdown', stop, { passive: true });
    track.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { stop(); goTo(index - 1); }
      if (e.key === 'ArrowRight') { stop(); goTo(index + 1); }
    });

    // Pause while hovered or focused, resume after — distinct from `stop`,
    // which is permanent.
    root.addEventListener('mouseenter', function () { window.clearInterval(timer); });
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin',  function () { window.clearInterval(timer); });
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { window.clearInterval(timer); } else { start(); }
    });

    paint();
    start();
  });
})();

/* ---------------------------------------------------------------------------
 * Nutriride — cart page without the full reload
 *
 * Warehouse's own cart controller, on a quantity change, does this:
 *
 *     if (theme.pageType === "cart") { window.location.reload(); }
 *     else { ...ajax re-render... }
 *
 * So the drawer updates in place while the cart *page* throws the whole
 * document away and fetches it again — every stylesheet, script, image and app
 * embed — to change one number. That is the lag: a reload, a flash of white, a
 * scroll jump to the top, and the chat widget and gift icon booting a second
 * time.
 *
 * This intercepts those controls before the theme's delegated handler sees them
 * and uses Shopify's Section Rendering API instead: `/cart/change.js` returns
 * the updated cart *and* the re-rendered section markup in a single request.
 * One round trip, no reload, scroll position kept.
 *
 * Cheaper than the theme's own ajax path too, which re-fetches the section
 * separately after the change (two round trips).
 *
 * Only the cart page is touched. The drawer already re-renders and is left
 * entirely alone.
 * ------------------------------------------------------------------------- */
(function () {
  if (!window.theme || window.theme.pageType !== 'cart') return;

  var section = document.querySelector('[data-section-type="cart"]');
  if (!section) return;

  var sectionId = section.getAttribute('data-section-id');
  if (!sectionId) return;

  var inFlight = false;

  function setBusy(node, busy) {
    var line = node && node.closest ? node.closest('.line-item') : null;
    if (line) line.classList.toggle('nr-line-busy', !!busy);
    section.classList.toggle('nr-cart-busy', !!busy);
  }

  /* Show the new number before the network answers.
   *
   * The request itself is ~570ms, most of it Shopify rendering the section, and
   * nothing client-side shortens that. What can be removed is the *wait*: the
   * figure the customer just clicked for appears at once and the line dims
   * slightly while the real total catches up. Measured 984ms to first visible
   * change before this; the server round trip is unchanged, but the customer no
   * longer watches it.
   *
   * Safe because the response overwrites the whole section a moment later, so a
   * rejected change (out of stock, quantity rule) corrects itself rather than
   * sticking.
   */
  function optimistic(origin, quantity) {
    var lineEl = origin && origin.closest ? origin.closest('.line-item') : null;
    if (!lineEl) return;

    if (quantity === 0) {
      lineEl.style.opacity = '0.3';
      return;
    }

    Array.prototype.forEach.call(
      lineEl.querySelectorAll('.quantity-selector__value'),
      function (input) {
        input.value = quantity;
        input.setAttribute('data-current-value', quantity);
      }
    );
  }

  function apply(line, quantity, origin) {
    if (inFlight) return;
    inFlight = true;
    optimistic(origin, quantity);
    setBusy(origin, true);

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        // Shopify still assumes this header on cart routes
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionId })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (cart) {
        var html = cart.sections && cart.sections[sectionId];
        if (!html) throw new Error('no section markup');

        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-section-type="cart"]');
        if (!fresh) throw new Error('section not found in response');

        section.innerHTML = fresh.innerHTML;

        var count = document.querySelector('.header__cart-count');
        if (count) count.textContent = cart.item_count;

        /* A private event carrying the cart we already have.
         *
         * The obvious choices all cost a request: `cart:refresh` makes the
         * theme fetch the section again, and `cart:updated` / `cart:rerendered`
         * each woke a listener that did the same — measured as two extra /cart
         * fetches landing 555ms after the click, re-rendering markup that had
         * just been swapped in.
         *
         * Passing the cart in the detail also saves the gift guard its own
         * /cart.js, since it can judge this payload directly. */
        document.dispatchEvent(new CustomEvent('nr:cart:changed', {
          bubbles: true,
          detail: { cart: cart }
        }));
      })
      .catch(function () {
        // Anything unexpected: fall back to the theme's behaviour rather than
        // leaving the customer looking at a stale cart.
        window.location.reload();
      })
      .then(function () {
        inFlight = false;
        setBusy(origin, false);
      });
  }

  /* Capture phase on document, so this runs before the theme's delegated
     listener on documentElement and can stop it reaching the reload. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]');
    if (!btn || !section.contains(btn)) return;

    var line = btn.getAttribute('data-line');
    var qty = btn.getAttribute('data-quantity');
    if (line === null || qty === null) return;

    e.preventDefault();          // the Remove control is a real <a href>
    e.stopImmediatePropagation();
    apply(parseInt(line, 10), parseInt(qty, 10), btn);
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('quantity-selector__value')) return;
    if (!section.contains(input)) return;

    var line = input.getAttribute('data-line');
    if (line === null) return;

    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return;

    e.stopImmediatePropagation();
    apply(parseInt(line, 10), qty, input);
  }, true);
})();

/* ---------------------------------------------------------------------------
 * Nutriride — lift the Shopify Inbox launcher clear of the bottom tab bar
 *
 * The chat bubble is anchored bottom-right with no awareness of the custom
 * mobile tab bar, so it sat on top of the bar and over the last row of product
 * cards.
 *
 * What is reachable: `<shopify-chat>` exposes an OPEN shadow root, and the
 * launcher lives directly inside it as
 * `DIV.activator-nudge > BUTTON.activator`, with `.activator__icon` and
 * `.activator__label` within. All of it can be restyled by appending a
 * stylesheet to that root — colour and position included. (An earlier probe hit
 * a different, closed node and I wrongly concluded the button was out of reach;
 * the real launcher is right here.)
 *
 * The app positions it at a hardcoded `bottom: 88px`, which knows nothing about
 * the custom mobile tab bar or a notched device's safe area. Tying it to
 * `--nr-tabbar-h` keeps it clear of the bar on every screen.
 *
 * The style is re-applied if the app re-renders the widget and drops it.
 *
 * Custom properties inherit through shadow boundaries, so `--nr-tabbar-h`
 * declared on :root resolves inside the shadow style.
 * ------------------------------------------------------------------------- */
(function () {
  var STYLE_ID = 'nr-chat-offset';
  var tries = 0;

  /* The launcher is two shadow roots deep:
   *   <shopify-chat>#shadow > div#shopify-element-wrapper
   *     > <shopify-agent-runtime>#shadow > .activator-nudge > button.activator
   *
   * CSS does not cross a shadow boundary, so a stylesheet appended to the OUTER
   * root has no effect on it — which is exactly what happened on the first
   * attempt. The style has to go into the runtime's own root, the one that
   * actually contains the button.
   */
  /* Deliberately does NOT wait for `.activator` to exist.
   *
   * The previous version returned the root only once the button was in it,
   * which meant the stylesheet could not arrive until after the button had
   * already been created — and therefore already painted at the app's own
   * near-black default. That is one guaranteed frame of black on every mount,
   * which is the flash still being reported after the observer fix.
   *
   * Injecting as soon as the shadow root exists puts the rules in place BEFORE
   * the button is appended, so its first paint is the styled one. A stylesheet
   * in an empty root is harmless; it simply waits for something to match.
   */
  function launcherRoot() {
    var chat = document.querySelector('shopify-chat');
    if (!chat || !chat.shadowRoot) return null;
    var runtime = chat.shadowRoot.querySelector('shopify-agent-runtime');
    return runtime && runtime.shadowRoot ? runtime.shadowRoot : null;
  }

  /* Hold the launcher back until it is styled.
   *
   * Timing fixes alone could not settle this: the flicker persisted in Safari
   * after the style was proven to land in the first frame the button existed in
   * a Chromium-based browser. Rather than keep chasing a race across engines,
   * this removes the race. `<shopify-agent-runtime>` lives in the OUTER shadow
   * root, so CSS there can reach it — it is hidden from the moment that root
   * appears, which is before the app has built anything inside it, and revealed
   * only once our stylesheet is in place. There is no longer an interval during
   * which an unstyled launcher could be painted, in any browser.
   *
   * `visibility`, not `display`: it keeps the element in layout, so nothing the
   * app measures changes.
   *
   * The fallback matters. If this script fails or the app changes shape, a
   * hidden chat button would be worse than an ugly one, so the gate removes
   * itself after 4 seconds regardless.
   */
  var GATE_ID = 'nr-chat-gate';

  function gate(outerRoot) {
    if (!outerRoot || !outerRoot.getElementById || outerRoot.getElementById(GATE_ID)) return;
    var g = document.createElement('style');
    g.id = GATE_ID;
    g.textContent = 'shopify-agent-runtime:not([data-nr-ready]) { visibility: hidden !important; }';
    outerRoot.appendChild(g);
    // Kept in step with the host failsafe below: the in-shadow gate must outlive
    // the host one, so a launcher that mounts late is still covered after the
    // host has been revealed.
    window.setTimeout(function () { if (g.parentNode) g.parentNode.removeChild(g); }, 9000);
  }

  function apply() {
    var chat = document.querySelector('shopify-chat');
    var runtime = chat && chat.shadowRoot && chat.shadowRoot.querySelector('shopify-agent-runtime');
    var root = launcherRoot();
    if (!root) return false;

    if (root.getElementById && root.getElementById(STYLE_ID)) {
      if (runtime) runtime.setAttribute('data-nr-ready', '');
      if (chat) chat.setAttribute('data-nr-ready', '');
      return true;
    }

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      /* Fade in rather than pop. The launcher mounts late, and before this it
         appeared abruptly — and briefly at the app's own 88px default before
         the rule below moved it. */
      '@keyframes nr-chat-in { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }',
      '.activator-nudge { animation: nr-chat-in 0.26s ease both; }',
      '@media (prefers-reduced-motion: reduce) { .activator-nudge { animation: none; } }',
      /* Clear the bottom tab bar and the home indicator — and, on a product
         page, the sticky add-to-cart bar.

         `--nr-widget-lift` is set on <html> by the sticky bar's own script and
         inherits across the shadow boundary, which is the only part of this
         widget the theme can reach. max() rather than a swap, so the launcher
         only moves when the bar is genuinely above its resting position; when
         the variable is absent the term is 0 and nothing changes. */
      '.activator-nudge {',
      '  bottom: max(calc(var(--nr-tabbar-h, 58px) + env(safe-area-inset-bottom, 0px) + 14px), var(--nr-widget-lift, 0px)) !important;',
      '  transition: bottom 0.24s cubic-bezier(0.22, 0.61, 0.36, 1) !important;',
      '}',
      '@media screen and (min-width: 750px) {',
      '  .activator-nudge { bottom: max(20px, var(--nr-widget-lift, 0px)) !important; }',
      '}',
      '@media (prefers-reduced-motion: reduce) { .activator-nudge { transition: none !important; } }',
      /* Brand it: the app ships a near-black pill that matches nothing else on
         the page. Petrol teal is the same accent the gift widget and the
         carousel arrows use. */
      /* #0A7FA8, not the #085E7B used elsewhere.
       *
       * The accent teal is genuinely dark — 7.25:1 against white — so on a
       * small pill it reads as near-black, which is what prompted "why is the
       * chat icon black". This is the lightest step that still clears WCAG AA
       * for normal text against the white label: measured 4.55:1, where the
       * next step up (#0C86B2) drops to 4.14 and fails. */
      '.activator {',
      '  background: #0A7FA8 !important;',
      '  color: #FFFFFF !important;',
      '  border: 0 !important;',
      '  border-radius: 999px !important;',
      '  box-shadow: 0 4px 14px rgba(2, 29, 39, 0.26) !important;',
      '  transition: background-color 0.16s ease, box-shadow 0.16s ease !important;',
      '}',
      '.activator:hover { background: #086A8C !important; box-shadow: 0 6px 18px rgba(2, 29, 39, 0.32) !important; }',
      '.activator:focus-visible { outline: 2px solid #FFFFFF !important; outline-offset: 2px !important; }',
      '.activator__label { color: #FFFFFF !important; font-weight: 600 !important; }',
      '.activator__icon svg, .activator__icon path { fill: currentColor !important; }',
      /* ---- the open panel --------------------------------------------
         The app ships the panel at 80% white, so the page scrolls visibly
         through the conversation. That is the whole of what looked unstyled:
         a chat window you can see the catalogue through reads as broken
         rather than translucent.

         Only the shell can be reached. The panel's contents are an iframe,
         and its colours come from the Inbox app's own settings, not here. */
      '.panel {',
      '  background: #FFFFFF !important;',
      '  box-shadow: 0 18px 50px rgba(2, 29, 39, 0.28) !important;',
      '  border: 1px solid rgba(2, 29, 39, 0.08) !important;',
      '}',
      '.panel__header { background: #FFFFFF !important; }'
    ].join('\n');
    root.appendChild(style);
    // Styled — safe to paint now. The runtime attribute clears the in-shadow
    // gate; the host attribute clears the one in custom.css.
    if (runtime) runtime.setAttribute('data-nr-ready', '');
    if (chat) chat.setAttribute('data-nr-ready', '');
    return true;
  }

  /* Why this keeps running instead of injecting once.
   *
   * The first version injected the style the first time it found the launcher
   * and then stopped watching. The app re-creates `<shopify-agent-runtime>` —
   * on opening and closing the chat, and on its own lazy re-mounts — and a
   * re-created element gets a BRAND NEW shadow root with none of our style in
   * it. The pill then reverts to the app's near-black default at its own 88px
   * offset, which is the "black again and wrongly placed" that came back.
   *
   * So detection is permanent and the injection is idempotent: `apply()`
   * returns early when the style is already in the current root, and re-adds it
   * to whatever root exists when it is not. Cost when nothing has changed is
   * three querySelectors and one getElementById.
   */
  /* Synchronous, not deferred.
   *
   * This used to hop through setTimeout(0), which runs after the browser has
   * painted — so even when the mutation was caught in the right frame, the
   * style landed one paint too late. apply() is idempotent and cheap (one
   * getElementById when nothing has changed), so it is safe to run inline in
   * the observer callback, before that paint happens.
   */
  function ensure() {
    wire();
    apply();
  }

  /* Observing the document is not enough.
   *
   * A MutationObserver does NOT see mutations that happen inside a shadow root,
   * and the launcher mounts inside two of them. So the document observer never
   * fired for the mount, and the only thing catching it was the 1.5s interval —
   * which left the pill black at the app's 88px offset for up to a second and a
   * half on every mount. That delay is the flash being reported, not a failure
   * to style.
   *
   * Each shadow root is therefore observed in its own right: the outer one to
   * catch <shopify-agent-runtime> being added, and the runtime's own to catch
   * the activator appearing inside it. A WeakSet keeps us from stacking
   * observers on a root we already watch, and lets a replaced root be collected.
   */
  var observed = new WeakSet();

  function observeRoot(root) {
    if (!root || !window.MutationObserver || observed.has(root)) return;
    observed.add(root);
    new MutationObserver(ensure).observe(root, { childList: true, subtree: true });
  }

  function wire() {
    var chat = document.querySelector('shopify-chat');
    if (!chat || !chat.shadowRoot) return;
    gate(chat.shadowRoot);
    observeRoot(chat.shadowRoot);
    var runtime = chat.shadowRoot.querySelector('shopify-agent-runtime');
    if (runtime && runtime.shadowRoot) observeRoot(runtime.shadowRoot);
  }

  function tick() { wire(); apply(); }

  function start() {
    tick();

    /* Whatever else happens, the launcher becomes visible. If this script
       fails, or the app changes shape so the stylesheet never lands, an
       unstyled chat button is recoverable — a permanently hidden one is not. */
    window.setTimeout(function () {
      var c = document.querySelector('shopify-chat');
      if (c) c.setAttribute('data-nr-ready', '');
    }, 8000);


    // The document observer still earns its place: it is what tells us
    // <shopify-chat> itself has been added, so we can reach its shadow root.
    if (window.MutationObserver) {
      new MutationObserver(tick).observe(document.documentElement, {
        childList: true, subtree: true
      });
    }

    // Backstop, now only for anything the three observers between them miss.
    window.setInterval(tick, 400);

    // Returning to a backgrounded tab is a common moment for the app to rebuild.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tick();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---------------------------------------------------------------------------
 * Close button on the gift popup
 *
 * The AppHero gift panel (.ahlGiftWdgCntHld) opens as a fixed card with no
 * visible way out — the only way to dismiss it is to find the gift icon again,
 * which the panel itself partly covers on a phone.
 *
 * The button does NOT hide the panel directly. It clicks the app's own
 * icon, which is how the app closes it, so the app's internal open/closed
 * state stays in step with what is on screen. Hiding the element behind the
 * app's back would leave it believing the panel is still open.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  var CARD = '.ahlGiftWdgCntHldIn';
  var TOGGLE = '.ahlGiftWdgIcnHldOver, .ahlGiftWdgIcnHld';
  var PANEL = '.ahlGiftWdgCntHld';
  var OVERLAY = '.ahlGiftWdgOverlay';

  // The app does not listen for `click` — a scripted one does nothing, which
  // is also why the panel cannot be opened from the console. It binds pointer
  // events, so the whole sequence has to be dispatched for the app to treat
  // this as a real tap on its own icon.
  function tap(el) {
    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (type) {
      var Ctor = (type.indexOf('pointer') === 0 && window.PointerEvent) ? PointerEvent : MouseEvent;
      el.dispatchEvent(new Ctor(type, { bubbles: true, cancelable: true, view: window }));
    });
  }

  function shown(sel) {
    var el = document.querySelector(sel);
    return (el && window.getComputedStyle(el).display !== 'none') ? el : null;
  }

  // The panel is only half of it. The app also puts up a full-screen backdrop
  // at z-index 2147483644, and closing the panel without it leaves an
  // invisible sheet over the whole page that swallows every click — which is
  // exactly what the first version of this did.
  function force() {
    var panel = shown(PANEL);
    if (panel) panel.classList.add('ahlGiftWdgClose');

    var overlay = shown(OVERLAY);
    if (overlay) overlay.style.display = 'none';

    var gift = document.querySelector('.ahl-gift-svg');
    var cancel = document.querySelector('.ahl-cancel-svg');
    if (gift) gift.classList.remove('ahlGiftWdgIcnHidden');
    if (cancel) cancel.classList.add('ahlGiftWdgIcnHidden');
  }

  function close() {
    // The backdrop is the app's own dismiss target, so going through it lets
    // the app tear down both pieces itself and keep its state straight.
    var overlay = shown(OVERLAY);
    if (overlay) tap(overlay);

    window.setTimeout(function () {
      if (!shown(PANEL) && !shown(OVERLAY)) return;   // the app handled it
      var toggle = document.querySelector(TOGGLE);
      if (toggle) tap(toggle);
      window.setTimeout(force, 140);
    }, 140);
  }

  function attach() {
    var card = document.querySelector(CARD);
    if (!card || card.querySelector('.nr-giftpop-close')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nr-giftpop-close';
    btn.setAttribute('aria-label', 'Close');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" ' +
      'stroke-width="2.4" stroke-linecap="round"/></svg>';

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      close();
    });

    card.appendChild(btn);
  }

  // Safety net, independent of our button: a visible backdrop with no panel
  // behind it is always wrong, and always means the page cannot be clicked.
  // Whatever causes it — our close, the app's own, a race between them — this
  // puts the page back within a second rather than leaving a shopper stuck.
  function unblock() {
    if (!shown(PANEL) && shown(OVERLAY)) {
      shown(OVERLAY).style.display = 'none';
    }
  }

  function tick() {
    attach();
    unblock();
  }

  function start() {
    tick();
    // The panel is the app's markup and is rebuilt as its contents change.
    new MutationObserver(tick).observe(document.body, { childList: true, subtree: true });
    window.setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   Cart page — sticky checkout bar
   ------------------------------------------------------------
   The bar carries the total and a jump to the Price details
   panel. The figure is copied from that panel rather than
   printed into the bar by Liquid: Warehouse re-renders the recap
   on every quantity change, and a number printed once at page
   load would quietly go stale the first time someone pressed +.

   On phones it is the only checkout button: the recap's own is
   hidden by CSS, so there is no visible/hidden state to keep in
   step and nothing that depends on scroll timing.

   It publishes `--nr-widget-lift`, the same variable the sticky
   add-to-cart uses, so the gift icon and the chat pill step over
   it without either of them needing to know this bar exists.
   ============================================================ */
(function () {
  'use strict';

  var docEl = document.documentElement;
  var bar, total, payable;

  function readPayable() {
    payable = document.querySelector('.nr-pricedetails__payable .cart-recap__price-line-price');
    return payable;
  }

  function sync() {
    if (!bar) return;
    total = total || bar.querySelector('.nr-cart-bar__total');
    if (!total || !readPayable()) return;
    var value = payable.textContent.trim();
    if (value && total.textContent.trim() !== value) total.textContent = value;
  }

  function publishLift() {
    if (!bar || window.getComputedStyle(bar).display === 'none') {
      docEl.style.removeProperty('--nr-widget-lift');
      return;
    }
    var resting = parseFloat(window.getComputedStyle(bar).bottom) || 0;
    docEl.style.setProperty('--nr-widget-lift', Math.round(resting + bar.offsetHeight + 12) + 'px');
  }

  function onDetailsClick(event) {
    var trigger = event.target.closest('[data-nr-price-details]');
    if (!trigger) return;
    var panel = document.querySelector('.nr-pricedetails__title');
    if (!panel) return;
    event.preventDefault();
    // window.scrollTo, never scrollIntoView: the panel can sit inside a
    // clipped container, and scrollIntoView would scroll that box instead.
    window.scrollTo({
      top: window.pageYOffset + panel.getBoundingClientRect().top - 90,
      behavior: 'smooth'
    });
  }

  function start() {
    bar = document.querySelector('.nr-cart-bar');
    if (!bar) return;

    sync();
    publishLift();

    document.addEventListener('click', onDetailsClick);
    window.addEventListener('resize', publishLift);

    // Warehouse re-renders the recap through its own section reload.
    document.addEventListener('theme:loading:end', function () {
      window.setTimeout(function () { sync(); publishLift(); }, 60);
    });

    // Quantity edits that patch the DOM in place raise no event of their own.
    new MutationObserver(sync).observe(document.body, {
      childList: true, subtree: true, characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
